/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownPostgradType } from '../models/db_DropdownPostgradType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PostgradTypes {
    /**
     * Get a list of postgrad types
     * @param postgradCourseId Postgrad Course ID
     * @param academicYear Academic Year
     * @returns db_DropdownPostgradType OK
     * @throws ApiError
     */
    public static listPostgradTypes(
        postgradCourseId?: number,
        academicYear?: number,
    ): CancelablePromise<Array<db_DropdownPostgradType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/postgrad-types',
            query: {
                'postgrad_course_id': postgradCourseId,
                'academic_year': academicYear,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
